import cookie from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import { identify } from '@cbhq/client-analytics';

// Cookie name for the device id set by the monorail
const COOKIE_DEVICE_ID = 'coinbase_device_id';

// https://www.wolframalpha.com/input?i=2.628%C3%9710%5E9+milliseconds
const ONE_MONTH_AS_MS = 2_628_000_000;

/**
 * Returns the current user's Device ID, which is set when the user makes their first
 * request to the monorail and is preserved in a cookie.  This is used as a unique
 * device identifier, for example in amplitude.
 */
export function getDeviceId() {
  let deviceId = cookie?.get(COOKIE_DEVICE_ID);
  if (!deviceId) {
    deviceId = uuidv4();
    cookie.set(COOKIE_DEVICE_ID, deviceId, { expires: new Date(Date.now() + ONE_MONTH_AS_MS) });
  }
  return deviceId;
}

/**
 * Gets the browser locale, defaulting to the specified default
 * if the browser locale could not be determined.
 *
 * @param defaultLocale The default locale to use.
 */
function getNavigatorLocale(defaultLocale = 'en'): string {
  if (navigator.languages && navigator.languages.length > 0) {
    return navigator.languages[0] || defaultLocale;
  }

  return navigator.language || defaultLocale;
}

export function identifyDevice() {
  // userId or deviceId are required for amplitude
  identify({
    locale: getNavigatorLocale('en'),
    deviceId: getDeviceId(),
  });
}
